import React from 'react';
import DOMPurify from 'dompurify';

// Tags whose content model can't legally contain a block-level <p> (heading
// and inline/phrasing contexts). CKEditor always wraps even single-line text
// in a <p>, so when rendering into one of these, unwrap that single
// enclosing paragraph first to avoid producing invalid nested HTML (which
// browsers silently mangle, e.g. dropping the wrapper's own class).
const BLOCK_INCOMPATIBLE_TAGS = new Set(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'a', 'li']);

const unwrapSingleParagraphOrHeading = (html) => {
  let text = html.replace(/^<(?:p|h[1-6])[^>]*>([\s\S]*)<\/(?:p|h[1-6])>$/i, '$1');
  return text.replace(/<\/?h[1-6][^>]*>/gi, '');
};

// Renders CMS content that was authored as rich text (HTML) in the admin panel.
// Content is sanitized server-side on save; DOMPurify here is a second layer of
// defense in case older/unsanitized data is still present.
const RichText = ({ html, as: Tag = 'div', className, id }) => {
  if (!html) return null;
  let sanitized = DOMPurify.sanitize(html);
  if (BLOCK_INCOMPATIBLE_TAGS.has(Tag)) {
    sanitized = unwrapSingleParagraphOrHeading(sanitized);
  }
  return (
    <Tag
      id={id}
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default RichText;
